<template>
  <div>
    <ul class="content-list mt-3">
      <li
        :key="k"
        v-for="(content, k) in contents"
        :class="`${current === content.path ? 'current' : ''}`"
      >
        <a :href="`#/contents/${content.path}`"> </a>
        {{ content.key | setText(content.title) }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState(["business"]),
    contents: {
      get() {
        return this.business ? this.business["contents"] : [];
      },
    },
  },
  props: {
    current: {
      default: function () {
        return "seasons";
      },
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.content-list {
  padding-bottom: 10px;

  display: flex;
  overflow-x: hidden;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    overflow-x: scroll;
    flex-wrap: nowrap;
  }

  max-width: 100%;

  & > li {
    &.current {
      // background: rgba(0, 0, 0, 0.9);
      // border-color: orange;
      border-color: #000511;
    }

    position: relative;

    & > a {
      z-index: 2;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    // -webkit-box-shadow: 4px 4px 16px 1px rgba(34, 60, 80, 0.2);
    // -moz-box-shadow: 4px 4px 16px 1px rgba(34, 60, 80, 0.2);
    // box-shadow: 4px 4px 16px 1px rgba(34, 60, 80, 0.2);
    font-size: 18px;
    border-bottom: 5px solid #fff;
    font-weight: bold;
    margin: 0 20px 10px 0;
    height: 35px;
    // background:rgba(0, 0, 0, 0.55);
    color: #111;
    max-width: 100%;
    white-space: nowrap;
    // height: 35px;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    &::first-letter {
      color: #000511;
    }
    &:hover {
      border-color: #999;
    }
  }
}
</style>
